import { render, staticRenderFns } from "./upload-design.vue?vue&type=template&id=20f08e26&scoped=true"
import script from "./upload-design.vue?vue&type=script&lang=js"
export * from "./upload-design.vue?vue&type=script&lang=js"
import style0 from "./upload-design.vue?vue&type=style&index=0&id=20f08e26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f08e26",
  null
  
)

export default component.exports